// TODO: get rid of the repetitive naming ...Model, it is clear this file is only for models
export const moduleModel = {
    index: { type: "number", required: true },
    name: { type: "text", required: true },
};

export const sessionModel = {
    description: { type: "text", required: true },
    startDate: { type: "date", required: true },
    endDate: { type: "date", required: true },
    contestStartDate: { type: "datetime-local", required: true },
    contestEndDate: { type: "datetime-local", required: true },
    contestResolveEndDate: { type: "datetime-local", required: true },
    examScheduleStart: { type: "datetime-local", required: true },
    examScheduleEnd: { type: "datetime-local", required: true },
    examSessionModules: {
        type: "select",
        multiple: true, // Multiple selection ?
        itemText: "name", // The key of the value to be displayed
        itemValue: "id", // The key of the value to be returned when element chosen
        items: "modules", // the endpoing that returns the items
        required: true,
    },
};

export const appointmentModel = {
    examDate: { type: "date", required: true },
    examCustomId: {
        type: "select",
        itemText: "examName",
        itemValue: "id",
        items: "getExamCustom",
        required: true,
    },
    examRoomId: {
        type: "select",
        itemText: "name",
        itemValue: "id",
        items: "examrooms",
        required: true,
    },
    examRoomSlotId: {
        type: "select",
        itemText: "startHour",
        itemValue: "id",
        items: "examroomslots",
        filter: "examRoomId",
        required: true,
    },
};

export const examroomModel = {
    name: { type: "text", required: true },
    building: { type: "text", required: true },
    seatNumbers: { type: "number", required: true },
    priority: { type: "number", required: true },
    rows: { type: "table" }, // for 'table' type - the key is the name of the entity
};

export const examroomslotModel = {
    examRoomId: {
        type: "select",
        itemText: "name",
        itemValue: "id",
        items: "examrooms",
        required: true,
    },
    startHour: { type: "time", required: true },
    endHour: { type: "time", required: true },
};

export const collegeModel = {
    code: { type: "text", required: true },
    name: { type: "text", required: true },
    defaultPSimpleQuestions: { type: "number", required: false },
    defaultPMultipleQuestions: { type: "number", required: false },
    allowEditPercent: { type: "3statebool", required: false },
    sections: { type: "table" },
};

export const sectionModel = {
    code: { type: "text", required: true },
    name: { type: "text", required: true },
    series: { type: "table", required: true },
    defaultPSimpleQuestions: { type: "number", required: false },
    defaultPMultipleQuestions: { type: "number", required: false },
    allowEditPercent: { type: "3statebool", required: false },
};

export const serieModel = {
    code: { type: "number", required: true },
    name: { type: "text", required: true },
    year: { type: "number", required: true },
    langCode: {
        type: "select",
        items: ["Romana", "English", "Franceza", "Maghiara"], // items can be a list as well
        required: false,
    },
};

export const rowModel = {
    rowNumber: { type: "number", required: true },
    seats: { type: "number", required: true },
    examRoomId: {},
};

export const studentModel = {
    firstName: { type: "text", required: true },
    lastName: { type: "text", required: true },
    year: { type: "number", required: true },
    email: { type: "email", required: true },
    cnp: { type: "text", required: true },
    phoneNumber: { type: "text", required: true },
    collegeId: {
        type: "select",
        multiple: false, // Multiple selection ?
        itemText: "name", // The key of the value to be displayed
        itemValue: "id", // The key of the value to be returned when element chosen
        items: "colleges", // the endpoing that returns the items
        required: true,
    },
    sectionId: {
        type: "select",
        multiple: false, // Multiple selection ?
        itemText: "name", // The key of the value to be displayed
        itemValue: "id", // The key of the value to be returned when element chosen
        items: "sections", // the endpoing that returns the items
        required: true,
    },
    seriesId: {
        type: "select",
        multiple: false, // Multiple selection ?
        itemText: "name", // The key of the value to be displayed
        itemValue: "id", // The key of the value to be returned when element chosen
        items: "series", // the endpoing that returns the items
        required: true,
    },
}

export const secretarModel = {
    id: { type: "text", required: true },
    email: { type: "email", required: true },
    college: {
        type: "select",
        itemText: "name", // The key of the value to be displayed
        itemValue: "id", // The key of the value to be returned when element chosen
        items: "colleges",
        required: true
    },
    section: {
        type: "select",
        itemText: "name", // The key of the value to be displayed
        itemValue: "id", // The key of the value to be returned when element chosen
        items: "sections",
        deps: ["colleges"],
        required: true,
    },
    series: {
        type: "select",
        multiple: true,
        itemText: "name", // The key of the value to be displayed
        itemValue: "id", // The key of the value to be returned when element chosen
        items: "series",
        deps: ["colleges", "sections"],
        required: true,
    }
}

export const universityYearModel = {
    startYear: { type: "number", required: false },
    endYear: { type: "number", required: false },
};

export default {
    moduleModel,
    sessionModel,
    appointmentModel,
    examroomModel,
    examroomslotModel,
    collegeModel,
    sectionModel,
    serieModel,
    rowModel,
    studentModel,
    secretarModel,
    universityYearModel
};
